<script setup lang="ts">
import FeedGrid from '@/components/distribute-feed-grid'
import { useMessageEmptyRecommendations } from '@/composables/useMessageEmptyRecommendations'
import { stateImages } from '@/utils/state-images'
import type { Props } from './type'

defineOptions({
  name: 'MessageEmptyState',
})

defineProps<Props>()

const { items, hasNext, loadingInitial, loadingMore, error, refresh, fetchNext } =
  useMessageEmptyRecommendations()
</script>

<template>
  <section class="message-empty-state">
    <div class="message-empty-state__hero">
      <img class="message-empty-state__image" :src="stateImages.emptyMascot" alt="消息空状态插画" />
      <h2 class="message-empty-state__title">
        <span>当前还没有开始跟角色互动</span>
        <span>为你推荐以下内容</span>
      </h2>
    </div>

    <FeedGrid
      :items="items"
      :loading-initial="loadingInitial"
      :loading-more="loadingMore"
      :error="error"
      :has-next="hasNext"
      @load-more="fetchNext"
      @retry="refresh"
    />
  </section>
</template>

<style scoped>
.message-empty-state {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.message-empty-state__hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 28px 0 8px;
  text-align: center;
}

.message-empty-state__image {
  width: var(--app-state-illustration-size-large);
  max-width: min(var(--app-state-illustration-size-large), 52vw);
  height: var(--app-state-illustration-size-large);
  object-fit: contain;
}

.message-empty-state__title {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin: 0;
  color: var(--app-text-main);
  font-size: 19px;
  font-weight: 400;
  line-height: 1.36;
}

@media (max-width: 720px) {
  .message-empty-state {
    gap: 6px;
  }

  .message-empty-state__hero {
    padding-top: 12px;
  }

  .message-empty-state__image {
    width: var(--app-state-illustration-size);
    max-width: min(var(--app-state-illustration-size), 56vw);
    height: var(--app-state-illustration-size);
  }

  .message-empty-state__title {
    font-size: 17px;
  }
}
</style>
